import React, {useRef, useCallback} from "react";
import {Container} from 'react-bootstrap'
import './Table.css'
import { AllCommunityModule, ModuleRegistry, QuickFilterModule, TextEditorModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import Loader from '../Loader/Loader'

ModuleRegistry.registerModules([AllCommunityModule, QuickFilterModule, TextEditorModule]);

export default function GridExample ({columns, data, handleSyncContactos, handleSyncPresupuestos, login}) {
  const gridRef = useRef();
  const defaultColDef = {
    flex: 1,
  };

  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value,
    );
  }, []);

  const quickFilterParser = useCallback((quickFilter) => {
    const quickFilterParts = [];
    let lastSpaceIndex = -1;
    const isQuote = (index) => quickFilter[index] === '"';
    const getQuickFilterPart = (lastSpaceIndex, currentIndex) => {
      const startsWithQuote = isQuote(lastSpaceIndex + 1);
      const endsWithQuote = isQuote(currentIndex - 1);
      const startIndex =
        startsWithQuote && endsWithQuote
          ? lastSpaceIndex + 2
          : lastSpaceIndex + 1;
      const endIndex =
        startsWithQuote && endsWithQuote ? currentIndex - 1 : currentIndex;
      return quickFilter.slice(startIndex, endIndex);
    };
    for (let i = 0; i < quickFilter.length; i++) {
      const char = quickFilter[i];
      if (char === " ") {
        if (!isQuote(lastSpaceIndex + 1) || isQuote(i - 1)) {
          quickFilterParts.push(getQuickFilterPart(lastSpaceIndex, i));
          lastSpaceIndex = i;
        }
      }
    }
    if (lastSpaceIndex !== quickFilter.length - 1) {
      quickFilterParts.push(
        getQuickFilterPart(lastSpaceIndex, quickFilter.length),
      );
    }
    return quickFilterParts;
  }, []);

  const quickFilterMatcher = useCallback(
    (quickFilterParts, rowQuickFilterAggregateText) => {
      let result;
      try {
        result = quickFilterParts.every((part) =>
          rowQuickFilterAggregateText.match(part),
        );
      } catch {
        result = false;
      }
      return result;
    },
    [],
  );

  return (
    <Container className="pt-3">
      <div style={{ width: "100%", height: "75vh" }}>
        <div className="example-header">
          <input
            type="text"
            id="filter-text-box"
            placeholder="Buscar..."
            className="mb-2"
            onInput={onFilterTextBoxChanged}
          />
          <button className="btn btn-outline-grey ms-2 mb-2" disabled={login} onClick={handleSyncContactos}>Sincronizar Contactos {login ? <Loader/> : ''}</button>
          <button className="btn btn-outline-grey ms-2 mb-2" disabled={login} onClick={handleSyncPresupuestos}>Sincronizar Presupuestos {login ? <Loader/> : ''}</button>
        </div>
        <AgGridReact
          ref={gridRef}
          rowData={data}
          columnDefs={columns}
          defaultColDef={defaultColDef}
          pagination={true}
          quickFilterParser={quickFilterParser}
          quickFilterMatcher={quickFilterMatcher}
        />
      </div>
    </Container>
    
  );
};